import { useAppSelector } from "@quest/hooks";

import Cookies from "js-cookie";
import { Circles } from "react-loader-spinner";

export default function Loader() {
  const primaryColor = Cookies.get("primary");

  const { primary } = useAppSelector((state) => state.theme);

  return (
    <div className="flex h-[80dvh] items-center justify-center w-full">
      <Circles
        height="80"
        width="80"
        color={primaryColor || primary || "#f5b064"}
        ariaLabel="circles-loading"
        visible={true}
      />
    </div>
  );
}
